import { Mesh, MeshStandardMaterial, PlaneGeometry } from 'three'

export class HtmlPlane {
    constructor({
        parent,
        width = 1.2,
        height = 1.92,
        position = { x: -1.8, y: 0.2, z: 0 },
        contrast = 1.22,
        saturation = 1.12,
        imageTexture = null,
        maskTexture = null,
    } = {}) {
        const material = new MeshStandardMaterial({
            color: 0xffffff,
            roughness: 0.5,
            metalness: 0.0,
            alphaTest: imageTexture ? 0 : 0.5,
            toneMapped: false,
            map: imageTexture || null,
            alphaMap: maskTexture || null,
            transparent: !!maskTexture,
        })

        material.onBeforeCompile = (shader) => {
            shader.uniforms.uContrast = { value: contrast }
            shader.uniforms.uSaturation = { value: saturation }
            shader.fragmentShader =
                'uniform float uContrast;\nuniform float uSaturation;\n' +
                shader.fragmentShader.replace(
                    '#include <map_fragment>',
                    `#include <map_fragment>
                    #ifdef USE_MAP
                        diffuseColor.rgb = (diffuseColor.rgb - 0.5) * uContrast + 0.5;
                        float _g = dot(diffuseColor.rgb, vec3(0.299, 0.587, 0.114));
                        diffuseColor.rgb = mix(vec3(_g), diffuseColor.rgb, uSaturation);
                        diffuseColor.rgb = clamp(diffuseColor.rgb, 0.0, 1.0);
                    #endif`,
                )
            material.userData.shader = shader
        }

        this.mesh = new Mesh(new PlaneGeometry(width, height), material)
        this.mesh.position.set(position.x, position.y, position.z)
        parent.add(this.mesh)
    }

    setContrast(v) {
        const s = this.mesh.material.userData.shader
        if (s) s.uniforms.uContrast.value = v
    }

    setSaturation(v) {
        const s = this.mesh.material.userData.shader
        if (s) s.uniforms.uSaturation.value = v
    }

    setTexture(texture) {
        const mat = this.mesh.material
        const hadMap = !!mat.map
        mat.map?.dispose?.()
        mat.map = texture || null
        mat.alphaTest = texture ? 0 : 0.5
        if (!!texture !== hadMap) mat.needsUpdate = true
        else mat.needsUpdate = true
    }

    setMask(texture) {
        const mat = this.mesh.material
        mat.alphaMap?.dispose?.()
        mat.alphaMap = texture || null
        mat.transparent = !!texture
        mat.needsUpdate = true
    }
}
